import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import type {
  HomeCuentaImagenBannerRow,
  HomeCuentaImagenesContent,
} from '../models/home-cuenta-imagenes-content.model';
import {
  CUENTA_IMAGE_JURIDICA_FALLBACK,
  CUENTA_IMAGE_NATURAL_FALLBACK,
  mapCuentaImagenesBannersToContent,
} from '../utils/home-cuenta-imagenes-banner.mapper';

/** Debe coincidir con `NeoBannerDTO.IMAGENES_REGISTRO` */
export const CUENTA_IMAGENES_BANNER_TIPO = 'ImagenesRegistro';

@Injectable({
  providedIn: 'root',
})
export class HomeCuentaImagenesService {
  private readonly fallbackContent: HomeCuentaImagenesContent = {
    naturalSrc: CUENTA_IMAGE_NATURAL_FALLBACK,
    juridicaSrc: CUENTA_IMAGE_JURIDICA_FALLBACK,
  };

  constructor(private readonly bancoldexService: BancoldexService) {}

  loadContent(): Observable<HomeCuentaImagenesContent> {
    return this.bancoldexService
      .getArchivosBannerActivos(CUENTA_IMAGENES_BANNER_TIPO)
      .pipe(
        map((response: any) => {
          const rows = normalizeCuentaImagenRows(response);
          if (!rows.length) {
            return this.fallbackContent;
          }
          return mapCuentaImagenesBannersToContent(rows, this.fallbackContent);
        }),
        catchError(() => of(this.fallbackContent))
      );
  }
}

function normalizeCuentaImagenRows(response: any): HomeCuentaImagenBannerRow[] {
  if (!response?.exitoso) {
    return [];
  }
  const raw = response.banners;
  if (!Array.isArray(raw)) {
    return [];
  }
  // Lista plana o agrupada (arrays anidados)
  return raw.flatMap((item: any) => (Array.isArray(item) ? item : [item]));
}
